import { useCallback } from 'react';
import { callApi } from '../utils/apiClient';


/**
 * Generic hook to load any master data list
 */
export const useMasterDataLoader = () => {
    /**
     * Loads data from a master endpoint
     * @param {string} endpoint API endpoint (e.g., API_ENDPOINTS.GET_MASTER_LIST)
     * @param {object} params Parameters to send in POST body
     * @param {function} setState State setter function to update data
     * @param {string} notFoundMessage Alert message when no data found
     */
    //   const loadMasterData = useCallback(async (endpoint, params, setState, notFoundMessage) => {
    //     try {
    //       const result = await callApi(
    //         endpoint,
    //         'POST',
    //         { 'Content-Type': 'application/json' },
    //         params
    //       );

    //       if (result && result.length > 0) {
    //         const updatedData =
    //           Array.isArray(result) && !result.includes('')
    //             ? [''].concat(result)
    //             : result;

    //         setState(updatedData);
    //       } else {
    //         alert(notFoundMessage);
    //       }
    //     } catch (error) {
    //       alert(error.message);
    //     }
    //   }, []);

    const loadMasterData = useCallback(async (endpoint, params, setState, notFoundMessage) => {
        try {
            const result = await callApi(
                endpoint,
                'POST',
                { 'Content-Type': 'application/json' },
                params
            );

            if (result && result.length > 0) {
                const updatedData =
                    Array.isArray(result) && !result.includes('')
                        ? [''].concat(result)
                        : result;

                setState(updatedData);
                return updatedData; // return so Promise.all can use it
            } else {
                alert(notFoundMessage);
                return null;
            }
        } catch (error) {
            alert(error.message);
            return null;
        }
    }, []);


    return { loadMasterData };
};
